import { render, staticRenderFns } from "./BalancePurchase.vue?vue&type=template&id=5d90b1d0&scoped=true&"
import script from "./BalancePurchase.vue?vue&type=script&lang=js&"
export * from "./BalancePurchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d90b1d0",
  null
  
)

export default component.exports